import { render, staticRenderFns } from "./ControlPoints.vue?vue&type=template&id=157b035c&"
import script from "./ControlPoints.vue?vue&type=script&lang=js&"
export * from "./ControlPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports